// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12mw1","content":"styles_content__9b06x","tableWrap":"styles_tableWrap__2EiL3"};